<template>
	<div class="xs-12">
		<core-form-input
			componentName="j-base-input-text"
			name="transactionNumber"
			:label="$t('debitNoteNumber')"
			v-model="form.transactionNumber"
		/>

		<core-form-input
			class="mt6"
			componentName="j-base-input-number"
			name="amount"
			:label="$t('amount')"
			placeholder="100.50"
			v-validate="{ required: true }"
			:validationErrors="errors"
			v-model="form.amount"
		/>

		<core-form-input
			class="mt6"
			componentName="core-select-currency"
			name="currencyCode"
			:label="$t('currency')"
			v-validate="{ required: true }"
			:validationErrors="errors"
			v-model="form.currencyCode"
		/>

		<core-form-input
			class="mt6"
			componentName="j-base-select"
			:options="options.status"
			name="status"
			:label="$t('status')"
			v-validate="{ required: true }"
			:validationErrors="errors"
			v-model="form.status"
		/>

		<core-form-input
			class="mt6"
			componentName="j-base-select"
			:options="paymentMethodOptions"
			name="method"
			:label="$t('payment_method')"
			v-model="form.method"
		>
			<span slot="label" class="fs3 c6">({{ $t("optional") }})</span>
		</core-form-input>

		<core-form-input
			componentName="j-base-input-text"
			id="date"
			name="date"
			:label="`${$t('date')} (DD/MM/YYYY HH:mm:ss)`"
			placeholder="01/01/2019 18:06:44"
			:description="$t('transaction_date_time_description')"
			v-validate="'date_format:DD/MM/YYYY HH:mm:ss'"
			v-model="form.dateTime"
			:validationErrors="errors"
			class="mt6"
			size="small"
		>
			<span slot="label" class="fs3 c6">({{ $t("optional") }})</span>
		</core-form-input>

		<!-- Slot passing up some methods -->
		<slot :onSubmit="onSubmit"></slot>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"

export default {
	components: { CoreFormInput },
	props: {
		initialPayload: {
			type: Object,
			required: false,
			default: () => ({})
		}
	},

	data() {
		return {
			form: {
				amount: "",
				status: null,
				method: null,
				dateTime: null,
				transactionNumber: null,
				currencyCode: this.$store.state.settings.preferredCurrency
			},

			options: {
				status: [
					{ name: "UNDEFINED", value: "UNDEFINED" },
					{ name: "NOT_STARTED", value: "NOT_STARTED" },
					{ name: "APPROVED", value: "APPROVED" },
					{ name: "REJECTED", value: "REJECTED" },
					{ name: "TIMEOUT", value: "TIMEOUT" },
					{ name: "CANCELLED_BY_USER", value: "CANCELLED_BY_USER" },
					{ name: "REFUNDED", value: "REFUNDED" }
				]
			}
		}
	},

	computed: {
		/**
		 * NOTE: Hack here, if tenant is asia or asia_uat return limited list
		 * This hack should be removed once we have settings for this in database
		 */
		paymentMethodOptions() {
			if (
				this.$store.state.tenantId === "asia" ||
				this.$store.state.tenantId === "asia_uat"
			)
				return [
					{ name: "CREDIT_CARD", value: "CREDIT_CARD" },
					{ name: "ATM", value: "ATM" },
					{ name: "BANK_TRANSFER", value: "BANK_TRANSFER" },
					{ name: "CHEQUE", value: "CHEQUE" }
				]
			else
				return [
					{ name: "CASH", value: "CASH" },
					{ name: "CREDIT_CARD", value: "CREDIT_CARD" },
					{ name: "GIRO", value: "GIRO" },
					{ name: "ATM", value: "ATM" },
					{
						name: "SELF_SERVICE_PAYMENT_MACHINE",
						value: "SELF_SERVICE_PAYMENT_MACHINE"
					},
					{ name: "BANK_TRANSFER", value: "BANK_TRANSFER" },
					{ name: "CHEQUE", value: "CHEQUE" }
				]
		}
	},

	methods: {
		/**
		 * Validate form and return payload of the form
		 */
		async onSubmit() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			this.$emit("submit", {
				...this.form,
				method: this.form.method ? this.form.method : null
			}) // make sure that empty string bcomes null as in APIs it's ENUMs and we have to send empty string
		}
	},

	watch: {
		/**
		 * When initial payload changes, upsert this.form
		 */
		initialPayload: {
			handler(newValue, oldValue) {
				this.form = { ...this.form, ...newValue }
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
